export const SET_ARQUIVOS = 'SET_ARQUIVOS';
export const LOADING_ARQUIVOS = 'LOADING_ARQUIVOS';